import { memo } from 'react';

import {
  useRedirectToJoinOrderModal,
  useKeepGroupOrderQueryParam,
  useRedirectDinerToMenuPage,
  useSetTimeoutForOrder
} from 'bento-ordering/group_ordering/hooks/index';

const GroupOrderManager = () => {
  useKeepGroupOrderQueryParam();
  useRedirectToJoinOrderModal();
  useRedirectDinerToMenuPage();
  useSetTimeoutForOrder();

  return null;
};

export default memo(GroupOrderManager);
